import { InMemoryHeader, InMemoryString } from "pbas-vue-components";
import { translate2 } from "../trans2";

const headers = [
  new InMemoryHeader({
    title: "Id",
    type: new InMemoryString("Identifier"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "headers.members_management.Member Group",
    type: new InMemoryString("MemberGroup", {
      getString: (item) => translate2(item.MemberGroup, "Name"),
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.plancoveragecommencement.conditions",
    type: new InMemoryString("SelfPaymentConditions", {
      getString: (item) => {
        const formatter = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
        });
        if (item.SelfPaymentConditions === null || item.SelfPaymentConditions === undefined || item.SelfPaymentConditions.length === 0) {
          return "";
        }
        var stringBuilder = [];
        for (let condition of item.SelfPaymentConditions) {
          console.log("condition is: ", condition);
          console.log(condition.CoverageIdentities);
          var coverageStr = condition.CoverageIdentities.map(
            (o) =>
              translate2(o.Current, "Name") +
              " (" +
              translate2(o.Current, "Description") +
              ")"
          ).join(", ");
          console.log(coverageStr);
          stringBuilder.push(formatter.format(condition.Rate))
          if (condition.MinimumYearsOfEmploymentIncluding !== null && condition.MinimumYearsOfEmploymentIncluding !== undefined) {
            if (condition.MaximumYearsOfEmploymentExcluding !== null && condition.MaximumYearsOfEmploymentExcluding !== undefined) {
              stringBuilder.push(`Years Of Employment limitation from ${condition.MinimumYearsOfEmploymentIncluding} (included) to ${condition.MaximumYearsOfEmploymentExcluding} (excluded) - ${coverageStr}`);
            } else {
              stringBuilder.push(`Years Of Employment limitation from ${condition.MinimumYearsOfEmploymentIncluding} (included) to ∞ - ${coverageStr}`);
            }
          } else {
            if (condition.MaximumYearsOfEmploymentExcluding !== null && condition.MaximumYearsOfEmploymentExcluding !== undefined) {
              stringBuilder.push(`Years Of Employment limitation to ${condition.MaximumYearsOfEmploymentExcluding} (excluded) - ${coverageStr}`);
            }
          }
          if (condition.MinimumAgeIncluding !== null && condition.MinimumAgeIncluding !== undefined) {
            if (condition.MaximumAgeExcluding !== null && condition.MaximumAgeExcluding !== undefined) {
              stringBuilder.push(`Age limitation from ${condition.MinimumAgeIncluding} (included) to ${condition.MaximumAgeExcluding} (excluded) - ${coverageStr}`);
            } else {
              stringBuilder.push(`Age limitation from ${condition.MinimumAgeIncluding} (included) to ∞ - ${coverageStr}`);
            }
          } else {
            if (condition.MaximumAgeExcluding !== null && condition.MaximumAgeExcluding !== undefined) {
              stringBuilder.push(`Age limitation from 0 to ${condition.MaximumAgeExcluding} (excluded) - ${coverageStr}`);
            }
          }
        }
        return stringBuilder.join("\n")
      },
      getHtml: (item, type) => {
        return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 800px'>" +
            type.getString(item, type) +
            "</div>"
        );
      }
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];
export default headers;
